// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"193":"e82f6bdd","421":"554d9e6a","556":"65c671e2","848":"fb229970"}[chunkId] + ".css";
};